import { CONVERTER_COMMON_LANG } from "./common";
import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_CONVERSION_FACTORS_LANG: {
  EMPTY_CONVERSION_FACTORS_TITLE: MvnCodeFE;
  EMPTY_CONVERSION_FACTORS_DESCRIPTION: MvnCodeFE;
  EMPTY_LIBRARY_DESCRIPTION: MvnCodeFE;
  OPEN_LIBRARY: MvnCodeFE;
  OPEN_LIBRARY_SUBTITLE: MvnCodeFE;
  OPEN_LIBRARY_SUCCESS: MvnCodeFE;
  OPEN_LIBRARY_FAIL: MvnCodeFE;
  OPEN_LIBRARY_ALERT_TITLE: MvnCodeFE;
  OPEN_LIBRARY_ALERT_MESSAGE: MvnCodeFE;
  SAVE_LIBRARY: MvnCodeFE;
  SAVE_LIBRARY_DIALOG_TITLE: MvnCodeFE;
  SAVE_LIBRARY_DIALOG_DESCRIPTION: MvnCodeFE;
  REMOVE_LIBRARY_DIALOG_TITLE: MvnCodeFE;
  REMOVE_LIBRARY_DIALOG_DESCRIPTION: MvnCodeFE;
  SAVE_LIBRARY_SUCCEED: MvnCodeFE;
  SAVE_LIBRARY_FAILED: MvnCodeFE;
  SAVE_LIBRARY_LIMIT_EXCEED: MvnCodeFE;
  SAVE_LIBRARY_NAME_PLACEHOLDER: MvnCodeFE;
  EXPORT_CONVERSION_FACTORS: MvnCodeFE;
  EXPORT_CONVERSION_FACTORS_SUCCEED: MvnCodeFE;
  EXPORT_CONVERSION_FACTORS_FAILED: MvnCodeFE;
  ADD_CONVERSION_FACTORS: MvnCodeFE;
  ADD_CONVERSION_FACTORS_SUCCEED: MvnCodeFE;
  ADD_CONVERSION_FACTORS_FAILED: MvnCodeFE;
  ADD_CONVERSION_FACTORS_DIALOG_TITLE: MvnCodeFE;
  ADD_CONVERSION_FACTORS_DIALOG_DESCRIPTION: MvnCodeFE;
  REMOVE_CONVERSION_FACTORS_SUCCEED: MvnCodeFE;
  REMOVE_CONVERSION_FACTORS_FAILED: MvnCodeFE;
  UPDATE_CONVERSION_FACTORS_FAILED: MvnCodeFE;
  REMOVE_LIBRARY_SUCCEED: MvnCodeFE;
  REMOVE_LIBRARY_FAILED: MvnCodeFE;
  UPDATE_LIBRARY_SUCCEED: MvnCodeFE;
  UPDATE_LIBRARY_FAILED: MvnCodeFE;
  FACTOR_TARGET_UNIT_VALUE_NUMERIC_ONLY: MvnCodeFE;
  LIBRARY_RENAME: MvnCodeFE;
  ADD_CONVERSION_FACTORS_DESCRIPTION: MvnCodeFE;
  FACTOR_SELECTED: MvnCodeFE;

  IMPORT_CONVERSION_FACTORS_SUCCESS: MvnCodeFE;
  IMPORT_CONVERSION_FACTORS_WITH_FAIL_COUNT_SUCCESS: MvnCodeFE;
  IMPORT_CONVERSION_FACTORS_FILE_TYPE_INVALID: MvnCodeFE;
  IMPORT_CONVERSION_FACTORS_FAIL: MvnCodeFE;

  VALIDATION_REQUIRED_SHEET_EXISTS_RULE: MvnCodeFE;
  VALIDATION_REQUIRED_COLUMN_EXISTS_RULE: MvnCodeFE;
  VALIDATION_COLUMN_ORDINAL_MATCH_RULE: MvnCodeFE;
  VALIDATION_MINIMUM_ROW_COUNT_RULE: MvnCodeFE;
  VALIDATION_MAXIMUM_ROW_COUNT_RULE: MvnCodeFE;
  VALIDATION_MAXIMUM_FILE_SIZE_RULE: MvnCodeFE;
  VALIDATION_NO_EMPTY_FIELDS_RULE: MvnCodeFE;
  VALIDATION_TARGET_UNIT_FACTOR_SYMBOL_RULE: MvnCodeFE;
  VALIDATION_TARGET_UNIT_FACTOR_FORMULA_RULE: MvnCodeFE;
  VALIDATION_NO_DIVISION_BY_ZERO_RULE: MvnCodeFE;
  VALIDATION_IDENTITY_FACTOR_REQUIRES_SAME_UNIT_RULE: MvnCodeFE;
} = {
  EMPTY_CONVERSION_FACTORS_TITLE: {
    ko: "등록된 데이터가 없습니다.",
    en: "No data is currently registered.",
  },
  EMPTY_CONVERSION_FACTORS_DESCRIPTION: {
    ko: "라이브러리 열기를 이용해 사용할 라이브러리를 선택해 주세요.",
    en: "Please select the library you want to use.",
  },

  EMPTY_LIBRARY_DESCRIPTION: {
    ko: "저장된 파일이 없습니다.",
    en: "There is no saved file.",
  },

  OPEN_LIBRARY: {
    ko: "라이브러리 불러오기",
    en: "Open Library",
  },

  OPEN_LIBRARY_SUBTITLE: {
    ko: "사용할 파일을 선택해 주세요.",
    en: "Select the library to use.",
  },

  OPEN_LIBRARY_SUCCESS: {
    ko: "라이브러리 불러오기를 완료했습니다.",
    en: "The library has been opened.",
  },

  OPEN_LIBRARY_FAIL: {
    ko: "라이브러리 불러오기에 실패했습니다.",
    en: "Failed to open the library.",
  },

  OPEN_LIBRARY_ALERT_TITLE: {
    ko: "변환계수 라이브러리 대체",
    en: "Conversion Factors Library Replacement",
  },

  OPEN_LIBRARY_ALERT_MESSAGE: {
    ko: "스터디에 적용된 변환계수 정보를 선택한 파일로 대체하시겠습니까?\n현재 설정된 상태는 초기화되어 재사용이 불가능합니다.",
    en: "Do you want to replace the Conversion Factors information applied to the study with the selected library?\nThe currently set state will be reset and cannot be reused.",
  },

  SAVE_LIBRARY: {
    ko: "라이브러리 저장",
    en: "Save Library",
  },

  SAVE_LIBRARY_DIALOG_TITLE: {
    ko: "라이브러리 저장",
    en: "Save Library",
  },

  SAVE_LIBRARY_DIALOG_DESCRIPTION: {
    ko: "저장할 라이브러리 이름을 입력해 주세요.",
    en: "Fill in the library name where you want to save.",
  },

  SAVE_LIBRARY_NAME_PLACEHOLDER: {
    ko: "라이브러리명 입력",
    en: "Enter library name",
  },

  SAVE_LIBRARY_SUCCEED: {
    ko: "라이브러리를 저장했습니다.",
    en: "The library has been saved.",
  },

  SAVE_LIBRARY_FAILED: {
    ko: "라이브러리 저장에 실패했습니다.",
    en: "Failed to save the library.",
  },

  SAVE_LIBRARY_LIMIT_EXCEED: {
    ko: "라이브러리 저장 한도를 초과했습니다.",
    en: "The library storage limit has been exceeded.",
  },

  REMOVE_LIBRARY_DIALOG_TITLE: {
    ko: "라이브러리 삭제",
    en: "Delete Library",
  },

  REMOVE_LIBRARY_DIALOG_DESCRIPTION: {
    ko: "라이브러리 삭제 후 복구가 불가능합니다.\n라이브러리를 삭제하시겠습니까?",
    en: "Deleting the library is irreversible.\nDo you want to delete the library?",
  },

  EXPORT_CONVERSION_FACTORS: {
    ko: "내보내기",
    en: "Export",
  },

  EXPORT_CONVERSION_FACTORS_SUCCEED: {
    ko: "내보내기를 완료했습니다.",
    en: "The library has been exported.",
  },

  EXPORT_CONVERSION_FACTORS_FAILED: {
    ko: "내보내기에 실패했습니다.",
    en: "Failed to export the library.",
  },

  ADD_CONVERSION_FACTORS: {
    ko: "변환계수 추가",
    en: "Add Conversion Factors",
  },

  ADD_CONVERSION_FACTORS_SUCCEED: {
    ko: "변환계수 추가를 완료했습니다.",
    en: "The Conversion Factors have been added.",
  },

  ADD_CONVERSION_FACTORS_FAILED: {
    ko: "변환계수 추가에 실패했습니다.",
    en: "Failed to add the Conversion Factors.",
  },

  ADD_CONVERSION_FACTORS_DIALOG_TITLE: {
    ko: "변환계수 추가",
    en: "Add Conversion Factor(s)",
  },

  ADD_CONVERSION_FACTORS_DIALOG_DESCRIPTION: {
    ko: "추가할 변수를 입력해 주세요.",
    en: "Enter the Conversion Factors to add.",
  },

  REMOVE_CONVERSION_FACTORS_SUCCEED: {
    ko: "변환계수 삭제를 완료했습니다.",
    en: "The Conversion Factors have been deleted.",
  },

  REMOVE_CONVERSION_FACTORS_FAILED: {
    ko: "변환계수 삭제에 실패했습니다.",
    en: "Failed to delete the Conversion Factors.",
  },

  UPDATE_CONVERSION_FACTORS_FAILED: {
    ko: "변환계수 변경에 실패했습니다.",
    en: "Failed to modify the Conversion Factors.",
  },
  FACTOR_TARGET_UNIT_VALUE_NUMERIC_ONLY: {
    ko: "Factor Target Unit 값은 숫자만 입력 가능합니다.",
    en: "The Factor Target Unit value can only be a number.",
  },
  REMOVE_LIBRARY_SUCCEED: {
    ko: "라이브러리 삭제를 완료했습니다.",
    en: "The Conversion Factors have been deleted.",
  },

  REMOVE_LIBRARY_FAILED: {
    ko: "라이브러리 삭제에 실패했습니다.",
    en: "Failed to delete the Conversion Factors.",
  },

  UPDATE_LIBRARY_SUCCEED: {
    ko: "이름변경을 완료했습니다.",
    en: "The name has been changed.",
  },

  UPDATE_LIBRARY_FAILED: {
    ko: "이름변경에 실패했습니다.",
    en: "Failed to change the name.",
  },

  ADD_CONVERSION_FACTORS_DESCRIPTION: {
    ko: "버튼을 눌러 변수를 추가하세요.",
    en: "Click the button to add variables.",
  },
  LIBRARY_RENAME: CONVERTER_COMMON_LANG.RENAME_VERB,
  FACTOR_SELECTED: {
    ko: "개 선택됨",
    en: " items selected.",
  },

  IMPORT_CONVERSION_FACTORS_SUCCESS: {
    ko: "총 {total}건 중 신규 {newCount}건 처리되었습니다.",
    en: "Processed {total} items: {newCount} new created.",
  },

  IMPORT_CONVERSION_FACTORS_WITH_FAIL_COUNT_SUCCESS: {
    ko: "총 {total}건 중 {successCount}건 성공, {failCount}건 실패하였습니다.",
    en: "Processed {total} items: {successCount} succeeded, {failCount} failed.",
  },
  IMPORT_CONVERSION_FACTORS_FILE_TYPE_INVALID: {
    ko: "지원하지 않는 파일 형식입니다. Excel 파일(.xlsx)을 업로드해 주세요.",
    en: "Unsupported file format. Please upload an Excel file (.xlsx).",
  },
  IMPORT_CONVERSION_FACTORS_FAIL: {
    ko: "파일 업로드 처리에 실패했습니다.",
    en: "Failed to process the file upload.",
  },

  VALIDATION_REQUIRED_SHEET_EXISTS_RULE: {
    ko: "유효하지 않은 파일 포맷입니다. 필수 시트 'Factors'가 없습니다.",
    en: "Invalid file format. Required sheet 'Factors' not found.",
  },
  VALIDATION_REQUIRED_COLUMN_EXISTS_RULE: {
    ko: "필수 컬럼이 누락되었습니다. {value}",
    en: "Missing required columns. {value}",
  },
  VALIDATION_COLUMN_ORDINAL_MATCH_RULE: {
    ko: "컬럼 순서가 템플릿과 일치하지 않습니다. Export로 받은 템플릿 파일을 사용해주세요.",
    en: "Column order does not match template. Please use the template file from export.",
  },
  VALIDATION_MINIMUM_ROW_COUNT_RULE: {
    ko: "데이터가 없습니다. 최소 1개 이상의 데이터 행이 필요합니다.",
    en: "No data found. At least 1 data row is required.",
  },
  VALIDATION_MAXIMUM_ROW_COUNT_RULE: {
    ko: "데이터 행이 너무 많습니다. 최대 10,000개까지 처리 가능합니다. (현재: {value}개)",
    en: "Too many data rows. Maximum 10,000 rows are allowed. (Current: {value} rows)",
  },
  VALIDATION_MAXIMUM_FILE_SIZE_RULE: {
    ko: "파일 크기가 너무 큽니다. 10MB 이하의 파일을 업로드해 주세요. (현재 크기: {value})",
    en: "File size is too large. Please upload a file smaller than 10MB. (Current size: {value})",
  },
  VALIDATION_NO_EMPTY_FIELDS_RULE: {
    ko: "비어 있는 항목이 존재합니다. 모든 항목에는 값이 존재해야 합니다. {value}",
    en: "Empty fields detected. All fields must contain a value. {value}",
  },
  VALIDATION_TARGET_UNIT_FACTOR_SYMBOL_RULE: {
    ko: "수식 오류: ‘x’가 없거나 허용되지 않은 피연산자가 포함되어 있습니다. 숫자와 ‘x’만 사용할 수 있습니다.",
    en: "Expression error: missing ‘x’ or unsupported operands detected. Only numbers and ‘x’ are permitted.",
  },
  VALIDATION_TARGET_UNIT_FACTOR_FORMULA_RULE: {
    ko: "'Conversion Factor to Target Unit'의 입력 값이 올바르지 않습니다. 숫자, 'NA', 또는 변환 계수식(사칙연산, (괄호), ^, 공백만 허용)",
    en: "The input value for 'Conversion Factor to Target Unit' is invalid. Only numbers, 'NA', or conversion formulas (basic arithmetic, parentheses, ^, and spaces) are allowed.",
  },
  VALIDATION_NO_DIVISION_BY_ZERO_RULE: {
    ko: "0으로 나눌 수 없습니다. 수식에서 0으로 나누는 부분을 제거해주세요.",
    en: "Division by zero is not allowed. Please ensure the denominator is not zero.",
  },
  VALIDATION_IDENTITY_FACTOR_REQUIRES_SAME_UNIT_RULE: {
    ko: "Conversion Factor가 1이지만 Source Units와 Target Units가 다릅니다. 확인이 필요합니다. (Source: {source}, Target: {target})",
    en: "Conversion Factor is 1, but Source Units and Target Units are different. Please verify. (Source: {source}, Target: {target})",
  },
};

MvnCodeInitiate(CONVERTER_CONVERSION_FACTORS_LANG);
